import { render, staticRenderFns } from "./WorkPlaces.vue?vue&type=template&id=01dc3911&scoped=true&"
import script from "./WorkPlaces.vue?vue&type=script&lang=js&"
export * from "./WorkPlaces.vue?vue&type=script&lang=js&"
import style0 from "./WorkPlaces.vue?vue&type=style&index=0&id=01dc3911&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dc3911",
  null
  
)

export default component.exports